export  function getBaseUrl() {return 'https://chime-meetings-backend.rgp-dev.com/';}
export  function getMessagingWssUrl() {return 'wss://h8qe3whsxk.execute-api.us-east-1.amazonaws.com/Prod';}